import { connect as formikConnect } from 'formik';
import React from 'react';

import { path } from '../../utils';

const withFormikWrapper = Component => formikConnect(
  ({
    formik: {
      values, errors, submitCount, setFieldValue,
    },
    name,
    helperText,
    modifyOnChange,
    ...rest
  }) => {
    const value = path(name, values);
    const isSubmitted = submitCount > 0;
    const error = path(name, errors);

    return (
      <Component
        onChange={(...props) => {
          const newValue = modifyOnChange
            ? modifyOnChange(...props)
            : props[0].target.value;
          setFieldValue(name, newValue);
        }}
        value={value}
        error={isSubmitted && Boolean(error)}
        helpText={isSubmitted ? error || helperText : helperText}
        {...rest}
      />
    );
  }
);

export default withFormikWrapper;
